<template>
  <div>
    <base-info-card
      :title="title"
      :subtitle="subtitle"
      space="4"
      color="primary"
    />

    <!--<base-text-field label="Name" />-->

    <!--<base-text-field label="Email" v-bind:model="name" />-->

    <base-text-field
      label="Betreff"
      :initialvalue="''"
      @update="setSubject($event)"
    />

    <base-textarea
      class="mb-6"
      label="Ihr Anliegen"
      :initialvalue="''"
      @update="setBody($event)"
    />

    <base-btn
      :color="!theme.isDark ? 'accent' : 'white'"
      outlined
      target="_blank"
      @click="sendMail"
    >
      Mail verfassen
    </base-btn>
  </div>
</template>

<script>
  export default {
    name: 'BaseContactForm',

    // Injected from the Vuetify Themeable mixin
    inject: ['theme'],
    props: {
      subtitle: String,
      title: {
        type: String,
        default: 'Teilen Sie uns Ihr Anliegen mit',
      },
    },

    data: () => ({
      subject: '',
      body: '',
    }),
    methods: {
      sendMail () {
        window.open('mailto:info@ifea-treuhand.ch?subject=' + this.subject + '&body=' + this.body)
        console.log(this.subject, this.body)
      },
      setBody (text) {
        this.body = text
      },
      setSubject (text) {
        this.subject = text
      },
    },
  }
</script>
